var exports = {
  "k": "x127c5a35--a5ca81--container",
  "x": "x127c5a35--a5ca81--thumbnail",
};

module.exports = exports;
